import { Ajax } from '@bamboohr/utils';

import { BenchmarkingModalOnSubmitService, BenchmarkingStatusService, BenchmarkingStatuses } from "./types";


export const benchmarkingOptOutService: BenchmarkingModalOnSubmitService = () => Ajax.put('/data_benchmarking_agreements/opt-out');
export const benchmarkingOptInService: BenchmarkingModalOnSubmitService = () => Ajax.put('/data_benchmarking_agreements/opt-in');
export const benchmarkingCancelService: BenchmarkingModalOnSubmitService = () => Ajax.put('/data_benchmarking_agreements/cancel');
export const benchmarkingStatusService: BenchmarkingStatusService = () => Ajax.get<{ status: BenchmarkingStatuses }>('/data_benchmarking_agreements').then(({ data: { status } }) => status);
